/**
 * Chuỗi của nhóm màn `ket-noi` (Kết nối nguồn) thuộc module `tro-ly-ai` — tạm tách tệp khi dựng song song, sẽ gộp
 * vào `vi.ts`. Port từ namespace `troLyAi.ketNoi` của web-portal native; bỏ các chuỗi về phòng ban.
 */
export const viKetNoi = {
  troLyAiKetNoi: {
    tieuDe: 'Kết nối nguồn dữ liệu',
    phuDe: 'Các hệ thống dữ liệu mà trợ lý được phép đọc — đọc trực tiếp hoặc qua bản sao cập nhật định kỳ, luôn bằng tài khoản chỉ đọc.',
    taiLieuKetNoi: 'Tài liệu hướng dẫn',
    taiLieuDsn: 'Hướng dẫn kết nối CSDL (DSN) — gửi quản trị CSDL',
    taiLieuGraphql: 'Hướng dẫn kết nối GraphQL — gửi người vận hành',
    taiLieuChuanVao: 'Chuẩn đầu vào GraphQL — gửi đội lập trình xây dựng endpoint',
    themCsdl: 'Thêm CSDL (DSN)',
    themGraphqlNut: 'Thêm GraphQL',
    themApiNut: 'Thêm API',
    rongTieuDe: 'Chưa kết nối nguồn nào',
    rongMoTa: 'Dùng DSN khi khách hàng chỉ có một cơ sở dữ liệu và một tài khoản chỉ đọc; dùng GraphQL khi khách hàng có đội phát triển xây dựng endpoint.',
    themDauTien: 'Thêm kết nối đầu tiên',
    danhSach: 'Các nguồn dữ liệu đã kết nối',
    // Thông báo sau thao tác
    noiDuoc: 'Kết nối thành công · đọc được {{n}} bảng',
    noiDuocChiThuTuc: 'Kết nối thành công · nguồn chỉ cho gọi thủ tục · {{n}} thủ tục gọi được',
    khongNoiDuoc: 'Không kết nối được — {{loi}}',
    daDungKho: 'Đã tạo kho lưu bản sao — {{ten}}',
    khongDungDuocKho: 'Không tạo được kho lưu bản sao — {{loi}}',
    dongBoBatDau: 'Đang cập nhật {{n}} bảng ở chế độ nền — theo dõi tiến độ ở màn Kho dữ liệu',
    khongDongBoDuoc: 'Không cập nhật được dữ liệu — {{loi}}',
    khongDoiDuoc: 'Không đổi được — {{loi}}',
    daDoiNhip: 'Đã đổi tần suất đồng bộ.',
    daDoiMoTa: 'Đã lưu mô tả nguồn.',
    daDoiCheDo: 'Đã đổi cách đọc dữ liệu.',
    daBoVaXoa: 'Đã xoá nguồn và kho dữ liệu.',
    daBoGiuKho: 'Đã xoá nguồn — kho dữ liệu được giữ nguyên.',
    khongXoaDuoc: 'Không xoá được — {{loi}}',
    daXoaKhoCu: 'Đã dọn bản sao cũ {{ten}}.',
    khongXoaDuocKhoCu: 'Không dọn được bản sao cũ — {{loi}}',
    // Hộp xác nhận
    xacNhanBo: 'Xoá nguồn “{{ten}}”?',
    xacNhanBoKhongKho: 'Nguồn này chưa tạo kho riêng. Khai báo nghiệp vụ, phân quyền và truy vấn mẫu của nguồn cũng bị xoá theo.',
    xacNhanXoaKho: 'Xoá nguồn và cơ sở dữ liệu {{ten}}?',
    xacNhanXoaKhoGhi: 'Không thể hoàn tác. Mọi dữ liệu đã đồng bộ về sẽ bị xoá cùng nguồn.',
    boNguon: 'Xoá nguồn',
    xoaCaKho: 'Xoá nguồn và kho',
    xacNhanDoiCheDo: 'Đổi cách đọc dữ liệu của “{{ten}}”?',
    xacNhanSangSaoChep: 'Câu hỏi sẽ chạy trên bản sao lưu trong hệ thống. Sau khi đổi, bấm “Tạo kho lưu bản sao” rồi “Cập nhật dữ liệu” trước khi hỏi được.',
    xacNhanSangTrucTiep: 'Từ giờ câu hỏi sẽ đọc trực tiếp CSDL của khách, đồng bộ theo lịch bị tắt. Kho bản sao cũ (nếu có) chưa bị xoá — dọn bằng “Dọn bản sao cũ” trong menu ⋯ của thẻ nguồn khi chắc chắn không quay lại chế độ sao chép.',
    doiCheDo: 'Đổi cách đọc',
    xacNhanXoaKhoCu: 'Dọn bản sao dữ liệu cũ {{ten}}?',
    xacNhanXoaKhoCuGhi: 'Giải phóng dung lượng của dữ liệu đã đồng bộ về. Nguồn, khai báo nghiệp vụ, phân quyền và thống kê cột được giữ nguyên — trợ lý vẫn hỏi trực tiếp được. Không thể hoàn tác: muốn quay lại chế độ sao chép thì phải tạo kho và đồng bộ lại từ đầu.',
    xoaKhoCu: 'Dọn bản sao cũ',
    // Khai nhanh theo mẫu
    khaiNhanh: 'Khai báo nhanh theo mẫu',
    khaiNhanhTieuDe: 'Khai báo nhanh cho “{{ten}}”',
    khaiNhanhSapGhi: 'Đã nhận diện đây là hệ SAP Business One. Trợ lý sẽ được cung cấp sẵn các nội dung dưới đây về nguồn này — cách đọc các bảng của SAP và cách hiểu số liệu kế toán Việt Nam. Nội dung này đi kèm mọi câu hỏi trên nguồn, nên hãy đọc qua trước. Có thể sửa lại ở Kho dữ liệu → Ghi chú & thuật ngữ.',
    khaiNhanhThuongGhi: 'Không thấy dấu hiệu của hệ SAP Business One (không có bảng jdt1, ojdt, oact), nên chỉ cung cấp phần kế toán Việt Nam. Trợ lý sẽ được cung cấp sẵn các nội dung dưới đây, kèm mọi câu hỏi trên nguồn — hãy đọc qua trước. Có thể sửa lại ở Kho dữ liệu → Ghi chú & thuật ngữ.',
    khaiNhanhKiem: 'Bốn câu nên chạy sau khi khai báo (không ghi vào bản khai báo)',
    khaiNhanhGhi: 'Ghi vào ghi chú nghiệp vụ',
    khaiNhanhDangDo: 'Đang đọc danh sách bảng của nguồn...',
    daKhaiNhanh: 'Hoàn tất. Trợ lý đã biết cách hiểu số liệu kế toán của nguồn này — vào Kho dữ liệu → Ghi chú & thuật ngữ để đọc lại và chỉnh cho khớp với doanh nghiệp.',
    daKhaiNhanhSap: 'Hoàn tất. Trợ lý đã biết cách đọc các bảng SAP và cách hiểu số liệu kế toán của nguồn này. Còn bốn câu cần kiểm tra — xem ở Kho dữ liệu → Ghi chú & thuật ngữ.',
    khaiNhanhHong: 'Chưa khai báo được — {{loi}}',
    khaiNhanhQuaDai: 'Ghi chú của nguồn này sẽ dài {{tong}} ký tự, vượt giới hạn {{tran}}. Hãy rút gọn ghi chú hiện có ở Kho dữ liệu → Ghi chú & thuật ngữ rồi khai báo lại.',
    // Bí mật webhook
    biMatTieuDe: 'Khoá bí mật webhook — chỉ hiện một lần',
    biMatGhi: 'Gửi cho đội kỹ thuật của nguồn. Hệ thống của họ gọi địa chỉ dưới đây mỗi khi có dữ liệu mới; nền tảng ghi nhận thành thông báo để người vận hành bấm đồng bộ ngay, hoặc để lịch tự chạy.',
    biMatCanhBao: 'Nền tảng chỉ lưu tham chiếu tới khoá bí mật này nên không hiển thị lại được. Nếu mất, hãy đặt lại bằng API.',
    toiDaLuu: 'Tôi đã lưu',
    chepKhoa: 'Chép đoạn gọi',
    daChep: 'Đã chép vào bộ nhớ tạm.',
  },
  troLyAiKetNoiThe: {
    trangThai: {
      draft: 'Chưa kiểm tra',
      connected: 'Đã kết nối',
      ready: 'Sẵn sàng',
      error: 'Lỗi kết nối',
    },
    loaiGraphql: 'GraphQL',
    loaiApi: 'API',
    nhanTrucTiep: 'Đọc trực tiếp',
    nhanSaoChep: 'Sao chép định kỳ',
    cachDocTrucTiep: 'mỗi câu hỏi đọc dữ liệu mới nhất',
    cachDocSaoChepTuDong: 'tự cập nhật mỗi {{n}} phút',
    cachDocSaoChepTay: 'cập nhật khi bấm',
    cachDocApi: 'mỗi câu hỏi gọi API nghiệp vụ',
    traLoiTheoKhuon: 'Trả lời theo truy vấn mẫu',
    traLoiTheoBanKhai: 'Trả lời theo khai báo nghiệp vụ',
    themMoTa: '+ Thêm mô tả nghiệp vụ',
    xemSoDo: 'Xem sơ đồ bảng',
    suaKetNoiApi: 'Sửa kết nối API',
    chuyenSangSaoChep: 'Đổi sang sao chép định kỳ',
    chuyenSangTrucTiep: 'Đổi sang đọc trực tiếp',
    chiTietKetNoi: 'Chi tiết kết nối',
    ctDiaChi: 'Địa chỉ',
    ctKhoBanSao: 'Kho bản sao',
    ctVaiDoc: 'Tài khoản chỉ đọc',
    ctXacThuc: 'Xác thực',
    moTaNguon: 'Mô tả nguồn',
    moTaNguonGoiY: 'Mô tả nghiệp vụ, ví dụ: Hệ thống bán quần áo chi nhánh Hà Nội',
    moTaNguonGhiChu: 'Dùng làm tiêu đề phần của nguồn này khi trợ lý trả lời từ nhiều nguồn. Bỏ trống thì dùng tên nguồn.',
    bangDocDuoc: '{{n}} bảng đọc được',
    thuTucGoiDuoc: '{{n}} thủ tục gọi được',
    chiThuTucSanSang: 'Nguồn chỉ cho gọi thủ tục — hỏi đáp qua truy vấn mẫu.',
    chiThuTucCanChuyen: 'Nguồn chỉ cho gọi thủ tục, không có bảng để trợ lý tự viết câu lệnh. Vào trang Truy vấn mẫu và chuyển sang khai báo bằng truy vấn mẫu thì hỏi đáp mới dùng được nguồn này.',
    luocDo: 'lược đồ',
    luocDoKhac: 'Lược đồ khác trên máy chủ này: {{ds}}',
    conKhoCu: 'Còn một bản sao dữ liệu cũ không còn dùng tới — có thể dọn trong menu ⋯ để giải phóng dung lượng.',
    tuDongBo: 'Tự cập nhật theo lịch',
    tuDongBoMoiTruoc: 'Tự cập nhật mỗi',
    tuDongBoMoiSau: 'phút',
    nhipNhan: 'Số phút giữa hai lần tự cập nhật',
    dongBoThuCong: 'Tự cập nhật (đang tắt)',
    kiemNoi: 'Kiểm tra kết nối',
    moKhuon: 'Khai báo truy vấn mẫu',
    moKhoDuLieu: 'Mở kho dữ liệu',
    dungKho: 'Tạo kho lưu bản sao',
    dongBo: 'Cập nhật dữ liệu',
  },
  troLyAiKetNoiThem: {
    themDsn: 'Thêm kết nối CSDL (DSN)',
    themGraphql: 'Thêm nguồn GraphQL',
    themApi: 'Thêm nguồn API',
    themNguon: 'Thêm nguồn',
    daKhaiNguon: 'Đã thêm nguồn — bấm “Kiểm tra kết nối” để xem tài khoản đọc được những gì.',
    khongTaoDuoc: 'Không tạo được — {{loi}}',
    tenHienThi: 'Tên hiển thị',
    tenViDu: 'Báo cáo tài chính 2026',
    maNguon: 'Mã nguồn',
    maNguonChuaCo: 'Mã sinh từ tên — gõ tên trước.',
    maNguonGhi: 'Sinh tự động từ tên. Mã được dùng trong tên cơ sở dữ liệu của bản sao nên không đổi được sau khi tạo kho.',
    cheDoLabel: 'Cách đọc dữ liệu',
    cheDoTrucTiep: 'Truy vấn trực tiếp (khuyên dùng)',
    cheDoSaoChep: 'Sao chép định kỳ về kho riêng',
    cheDoTrucTiepGhi: 'Mỗi câu hỏi đọc trực tiếp CSDL này — nền tảng chỉ lưu lược đồ, khai báo nghiệp vụ và thống kê cột, không lưu dòng dữ liệu nào. Phù hợp khi CSDL của khách đã là bản sao và chịu được tải truy vấn.',
    cheDoSaoChepGhi: 'Dữ liệu được đồng bộ về kho riêng theo lịch, câu hỏi chạy trên bản sao. Dùng khi CSDL của khách có tài nguyên hạn chế, không nên nhận truy vấn báo cáo.',
    loaiCsdlLabel: 'Loại cơ sở dữ liệu',
    luocDoLabel: 'Lược đồ',
    luocDoGhi: 'Bỏ trống dùng mặc định.',
    mayChu: 'Máy chủ',
    cong: 'Cổng',
    congGhi: 'Bỏ trống dùng mặc định.',
    tenCsdl: 'Tên cơ sở dữ liệu',
    taiKhoan: 'Tài khoản',
    matKhau: 'Mật khẩu',
    hienMatKhau: 'Hiện',
    anMatKhau: 'Ẩn',
    hienMatKhauNhan: 'Hiện mật khẩu',
    anMatKhauNhan: 'Ẩn mật khẩu',
    danDsn: 'Hoặc dán chuỗi kết nối (DSN)',
    dsnGhi: 'Có sẵn chuỗi kết nối thì dán vào đây, các ô trên sẽ tự điền. Mật khẩu được tách và cất vào kho bí mật ngay khi lưu — phần hiển thị lại sau đó chỉ còn user:***@host/db.',
    xinQuyen: 'Xin quản trị CSDL cấp tài khoản chỉ đọc:',
    mssqlCanhBao: 'SQL Server không có công tắc chỉ đọc ở mức phiên, nên quyền của tài khoản là lớp bảo vệ duy nhất.',
    pgGhi: 'Nền tảng còn bật default_transaction_read_only ở tầng máy chủ — nhưng đó chỉ là lớp bảo vệ thứ hai; quyền của tài khoản phía khách hàng mới là lớp bảo vệ chính.',
    endpoint: 'Endpoint GraphQL',
    khoaApi: 'Khoá gọi API (tuỳ chọn)',
    khoaApiGhi: 'Gửi kèm dạng Authorization: Bearer. Lưu trong kho bí mật, không bao giờ hiển thị lại.',
    dongBoTheoLich: 'Đồng bộ theo lịch',
    moiPhut: 'Mỗi (phút)',
    baBuocGhi: 'Thực hiện lần lượt ba bước: khai báo, kiểm tra kết nối, tạo kho. Ba bước tách riêng vì mỗi bước có nguyên nhân lỗi và cách xử lý khác nhau.',
    baBuocGhiTrucTiep: 'Khai báo xong bấm “Kiểm tra kết nối” — kết nối thành công là hỏi được ngay, không cần tạo kho.',
    baBuocGhiApi: 'Khai báo xong bấm “Kiểm tra kết nối”, rồi sang Truy vấn mẫu để khai báo từng API.',
    apiDiaChiGoc: 'Địa chỉ gốc của API',
    apiDiaChiGocGhi: 'Phần chung của mọi API nghiệp vụ, ví dụ https://erp.khach.vn/api. Đường dẫn riêng của từng nghiệp vụ khai báo ở truy vấn mẫu.',
    apiDiaChiSai: 'Địa chỉ phải bắt đầu bằng http:// hoặc https://.',
    apiXacThuc: 'Cách xác thực',
    apiXacThucNone: 'Không cần khoá',
    apiXacThucBearer: 'Bearer token',
    apiXacThucApiKey: 'API key',
    apiXacThucBasic: 'Tài khoản + mật khẩu (Basic)',
    apiTenKhoa: 'Tên header mang khoá',
    apiViTriKhoa: 'Gửi khoá qua',
    apiViTriHeader: 'Header',
    apiViTriQuery: 'Tham số trên URL',
    apiTenDangNhap: 'Tên đăng nhập',
    apiKhoa: 'Khoá / mật khẩu',
    apiKhoaGhi: 'Lưu trong kho bí mật, không bao giờ hiển thị lại. Mọi truy vấn mẫu của nguồn này dùng chung khoá này.',
    apiKhoaGiuNguyen: 'Để trống là giữ khoá đang lưu. Khoá đã lưu không bao giờ hiện lại.',
    apiThoiGianCho: 'Chờ tối đa (giây)',
    apiThoiGianChoGhi: 'API báo cáo tính trên dữ liệu lớn thường chậm. Tối đa 60 giây.',
    apiHopDongTieuDe: 'API nghiệp vụ phải trả về đúng dạng',
    apiHopDongGhi: 'Phía API tự lọc, cộng và phân quyền dữ liệu — giống một thủ tục trong CSDL. Nền tảng chỉ khai báo, gọi và trình bày. Lỗi nghiệp vụ trả mã 4xx kèm trường message.',
    suaKetNoiApi: 'Sửa kết nối API',
    luuKetNoiApi: 'Lưu kết nối',
    daLuuKetNoiApi: 'Đã lưu kết nối. Bấm “Kiểm tra kết nối” để thử lại.',
  },
  troLyAiKetNoiSoDo: {
    tieuDe: 'Sơ đồ dữ liệu — {{ten}}',
    changNguonDsn: 'Cơ sở dữ liệu khách hàng',
    changNguonGraphql: 'Endpoint GraphQL',
    luocDoLa: 'lược đồ {{luocDo}}',
    changDongBo: 'Đồng bộ',
    moiPhut: 'tự chạy mỗi {{n}} phút',
    thuCong: 'chạy thủ công',
    soLieuToi: 'dữ liệu cập nhật đến {{luc}}',
    chuaDongBo: 'chưa đồng bộ lần nào',
    changKho: 'Kho bản sao',
    chuaDungKho: 'chưa tạo kho',
    khoGhi: '{{n}} bảng · {{dong}} dòng',
    changVaiDoc: 'Tài khoản chỉ đọc',
    vaiDocGhi: 'câu SQL do mô hình sinh chạy bằng tài khoản này',
    changTroLy: 'Trợ lý AI',
    sinhSql: 'sinh SQL từ câu hỏi',
    troLyGhi: 'Hỏi đáp AI · Trò chuyện với bot',
    altSoDo: 'Sơ đồ quan hệ: {{bang}} bảng, {{canh}} quan hệ',
    chuThichFk: 'khoá ngoại',
    chuThichChieu: 'chiều dữ liệu dùng chung',
    chuThichNhan: '1 / 0..* là bản số ở hai đầu quan hệ',
    phongTo: 'Phóng to',
    thuNho: 'Thu nhỏ',
    vuaKhung: 'Vừa khung',
    congCuTay: 'Chế độ kéo sơ đồ — bấm không chọn bảng',
    rongMoTa: 'Nguồn này chưa khai báo bảng nào. Hãy kiểm tra kết nối rồi xác nhận lược đồ ở màn Kho dữ liệu.',
    loiTieuDe: 'Không đọc được khai báo của nguồn',
    loiMoTa: 'Thử lại, hoặc kiểm tra nguồn còn tồn tại không.',
    khoVaLuocDo: '{{kho}} · lược đồ {{luocDo}}',
    chayDongChay: 'Mô phỏng luồng JOIN',
    dung: 'Dừng',
    duongJoinCua: 'đường JOIN của {{ten}}',
    moiDuongJoin: 'mọi đường JOIN',
    demBangQuanHe: '{{bang}} bảng · {{canh}} quan hệ',
    ghiChayDongChay: 'Đang minh hoạ đường đi của một câu JOIN, không phải luồng đồng bộ — hai bảng trong bản sao không trao đổi dữ liệu với nhau. Bấm vào một bảng để chỉ xem đường của bảng đó.',
    chuaKhaiQuanHeTieuDe: 'Chưa khai báo quan hệ nào.',
    chuaKhaiQuanHeMo: 'Bản sao không có khoá ngoại, nên đây là nơi duy nhất cho mô hình biết được phép JOIN bảng nào với bảng nào. Chưa khai báo thì mọi câu hỏi cần nối hai bảng sẽ không trả lời được. Hãy chạy “Dò mã & quan hệ” ở màn Kho dữ liệu.',
    boChon: 'Bỏ chọn',
    motDongLa: 'một dòng = {{grain}}',
    soMa: '{{n}} mã',
    soCot: '{{n}} cột',
    soNoi: '{{n}} nối',
    chuaNoi: 'chưa nối',
    locBang: 'Lọc bảng...',
    khongKhop: 'Không bảng nào khớp “{{loc}}”.',
    danhSachBang: 'Danh sách bảng',
  },
} as const;
